import { render } from "./AuthActions.vue?vue&type=template&id=64517a1e"
import script from "./AuthActions.vue?vue&type=script&lang=js"
export * from "./AuthActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__